import { itApp, itWebsite } from './strings';

const en = {
  translation: {
    ...itWebsite,
    ...itApp
  }
};

export default en;
